var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7125 7.28752L14.7125 0.287516C14.522 0.101794 14.266 -0.00148383 14 1.61126e-05H2C1.46957 1.61126e-05 0.960859 0.21073 0.585786 0.585802C0.210714 0.960875 0 1.46958 0 2.00002V24C0 24.5304 0.210714 25.0392 0.585786 25.4142C0.960859 25.7893 1.46957 26 2 26H20C20.5304 26 21.0391 25.7893 21.4142 25.4142C21.7893 25.0392 22 24.5304 22 24V8.00002C22.0015 7.73397 21.8982 7.47802 21.7125 7.28752ZM15 19H7C6.73478 19 6.48043 18.8947 6.29289 18.7071C6.10536 18.5196 6 18.2652 6 18C6 17.7348 6.10536 17.4804 6.29289 17.2929C6.48043 17.1054 6.73478 17 7 17H15C15.2652 17 15.5196 17.1054 15.7071 17.2929C15.8946 17.4804 16 17.7348 16 18C16 18.2652 15.8946 18.5196 15.7071 18.7071C15.5196 18.8947 15.2652 19 15 19ZM15 15H7C6.73478 15 6.48043 14.8947 6.29289 14.7071C6.10536 14.5196 6 14.2652 6 14C6 13.7348 6.10536 13.4804 6.29289 13.2929C6.48043 13.1054 6.73478 13 7 13H15C15.2652 13 15.5196 13.1054 15.7071 13.2929C15.8946 13.4804 16 13.7348 16 14C16 14.2652 15.8946 14.5196 15.7071 14.7071C15.5196 14.8947 15.2652 15 15 15ZM14 8.00002V2.50002L19.5 8.00002H14Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.36c87e93751b17b5d0f917d0a3780311.svg";
export { ForwardRef as ReactComponent };